//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import tips from './components/tips'
import guide from './components/guide'
import Frame from './components/frame'
import Location from './components/location'
import { risk } from '@/model/activation/riskGames'
import { Share,CacheModule } from '@/utils/commonUtils'

  export default {
    data() {
      return {
        lifeValue:3, //生命值
        question:'', //问题
        riskList:[],
        activeNum:0, // 第几个问题 
        image_url:'',
        answer:'', //回答正确的弹框文案 
        state:null,
        tipsShow:false, 
        guideShow:false, 
        classify:false, //true为引导遮罩 false为分享遮罩
        // ----Location
        start_coordinate:{x:45,y:183}, //起点坐标
        end_coordinate:{x:115,y:203}, //终点坐标
        Odata:{
          // state:'', // 点击的坐标是否在区域内
          // x:'', // 点击的坐标
          // y:''
        },
        timer:null,
        fadeShow:true, //动效
      }
    },
    components: {
      tips,
      Frame,
      Location,
      guide
    },
    created () {
      
      // 获取缓存
      if(CacheModule.get('riskGamesLife') == null){
        this.lifeValue = 3
      }else{
        this.lifeValue = CacheModule.get('riskGamesLife');
      };
      this.activeNum = CacheModule.get('riskGamesNum') || 0;
      if(this.activeNum == 3){
        this.$router.replace({
          path:'/result',
          query:{
            no:this.activeNum.toString(),
            flag:'postdisable'
          }
        })
      }else{
        this.getInfo();
      }
      

    },
    mounted () {
      let obj ={
          'shareTitle':'瘦脸针避坑挑战Come on！',
          'shareContent':  '想要小V脸、一字肩？闯关答题还能赢MAC口红哦~',
          'shareTimelineContent':'瘦脸针避坑挑战Come on！',
          'shareUrl': `https://${window.location.host}/riskGames?activityId=game&from_action=game_url`,
          'shareImgurl': 'https://static.soyoung.com/sy-pre/shareicon-1596528600703.png',
          'rightBtnStatus': 1
      }

      Share(obj,'sybao_ins_activity_share_result_sys',obj,()=>{ this.shareS() });
      // 游戏进度存取
      if(!CacheModule.get('riskGames')){
        CacheModule.set('riskGames',true) //设置是否为初次进入
        CacheModule.set('riskGamesLife',this.lifeValue) //存储生命值
        CacheModule.set('riskGamesNum',this.activeNum) //存储答题进度
        this.guideShow = true;
        this.classify = true;
      };
      this.STATISTICS('load','sybao_ins_game_answer_page',{'question_id':this.activeNum.toString()});
      
      // 安卓分享成功的回调
      window.receiveAndriod = (num)=>{
        console.log(num+'安卓分享成功')
        this.shareS()
      }
      
    },
    beforeDestroy(){
      window.receiveAndriod = undefined
    },
    watch: {
      lifeValue(newValue, oldValue) {
        CacheModule.set('riskGamesLife',newValue) //生命值变更存储
      },
      activeNum(newValue, oldValue){
        CacheModule.set('riskGamesNum',newValue) //答题进度变更存储

      },
      guideShow(newValue, oldValue){  //ios 唤起分享遮罩后三秒生命值自动+1
        if(newValue && !this.classify && this.CHANNAL_ID == 'APP' && this.IOS_AND == 'IOS'){ 
          clearInterval(this.timer )
          this.timer = setTimeout(() =>{
            this.shareS()
          },3000)
        }
      }
    },
    methods: {
      shareS(){
        if(this.guideShow && this.lifeValue == 0){
          this.guideShow = false;
          this.lifeValue += 1;
          this.fadeShow = false;
        }
      },
      show(str) {
        this.tipsShow = true;
        this.state = str;
        this.fadeShow = true; 
        // alert(this.activeNum)
        if(str == 'err'){
          this.STATISTICS('click','sybao_ins_game_wrong_exposure',{question_id:this.activeNum.toString()});
        }else if(str == 'right' || str == 'end'){
          this.STATISTICS('click','sybao_ins_game_correct_exposure',{question_id:this.activeNum.toString()});
        }else if(str == 'noLife'){
          this.STATISTICS('click','sybao_ins_game_over_exposure',{question_id:this.activeNum.toString()});

        }

      },
      // 拿到点击的信息
      save(data){
        this.Odata = data;
      },
      // 获取问题
      getInfo(){
        risk().then(res =>{
          this.riskList = res;
          this.question = this.riskList[this.activeNum ].question;
          this.answer = this.riskList[this.activeNum ].answer;
          this.start_coordinate = this.riskList[this.activeNum ].start_coordinate;
          this.end_coordinate = this.riskList[this.activeNum ].end_coordinate;
          this.image_url = this.riskList[this.activeNum ].image_url
        })
      },
      // 点击怀疑
      sub(){
          this.STATISTICS('click','sybao_ins_game_answer_click',{question_id:this.activeNum.toString()});

        // 生命值为0
        if(this.lifeValue == 0 || this.lifeValue < 0){
            this.show('noLife')  //无生命值
            return false;
        }
        this.$refs.loaction.show = false
        if(Object.keys(this.Odata).length == 0){
          this.$toast("请先点击图中你怀疑的人或物");

        }else{
          if(this.Odata.state){
            this.activeNum += 1

            if(this.activeNum == 3 || this.activeNum -3 > 0){
              this.show('end') //结束
            }else{
              this.show('right') //正确
            }
          }else{
            this.show('err') //错误
            this.lifeValue -=1;
          }
        }
      },
      leftBtn(data){
        this.tipsShow = false;
        this.Odata = {};
        if(data == 'noLife'){ //复活
          // alert("复活")
          this.STATISTICS('click','sybao_ins_game_reborn_click',{question_id:this.activeNum.toString()});

          this.guideShow = true;
          this.classify = false;
          // guideShow
        }else if(data == 'right'){ //正确
          this.STATISTICS('click','sybao_ins_game_next_click',{question_id:this.activeNum.toString()});
          
          this.question = this.riskList[this.activeNum].question;
          this.answer = this.riskList[this.activeNum].answer;
          this.start_coordinate = this.riskList[this.activeNum].start_coordinate;
          this.end_coordinate = this.riskList[this.activeNum].end_coordinate;
          this.image_url = this.riskList[this.activeNum].image_url;

        }else if(data == 'err'){ // 错误
          this.STATISTICS('click','sybao_ins_game_tryagain_click',{question_id:this.activeNum.toString()});
          if(this.lifeValue == 0 || this.lifeValue < 0){
            this.show('noLife')
          }else{
            this.fadeShow = false; 
          }
        }else if(data == 'end'){ //答题结束
            this.rightBtn();
        }
      },
      rightBtn(){ //查看结果 
        this.STATISTICS('click','sybao_ins_game_myscore_click');
        this.$router.replace({
          path:'/result',
          query:{
            no:this.activeNum.toString(),
            flag:'postdisable'
          }
        })
      },
      close(){ //分享弹框关闭
        this.guideShow = false;
        if(this.IOS_AND == 'IOS'){ 
          clearInterval(this.timer )
          this.shareS()
        }
      }

    },
  }
